<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="config-list"
            :afterUpdate="afterUpdate"
            :url="url"
            :tableHeight="tableHeight"
            :columns="columnList"
            :buttons="[]"
            :addButton="{ enabled: false, permission: 'config:create' }"
            :updateButton="{ permission: 'default' }"
            align="left"
        >
            <slot slot="filter">
                <el-col :span="4">
                    <item-input type="select" v-model="catetory" :options="catetory_list" :clearable="true" placeholder="请选择分类" @input="reload"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ConfigIndex`,
    props: {},
    data() {
        return {
            title: `参数设置`,
            catetory: ``,
            catetory_list: [],
            configsBackUp: [],
            url: {
                baseURL: `/api/AcisSystem/Config`,
                get: () => {
                    return this.loadConfig()
                }
            }
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_document_list`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 165) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `key`,
                    label: `名称`,
                    width: `200`,
                    isListable: true,
                    isCreatable: true,
                    searchable: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `catetory`,
                    label: `分类`,
                    width: `100`,
                    isListable: true,
                    isEditable: false,
                    options: this.catetory_list,
                    searchable: false
                },
                {
                    type: `textarea`,
                    prop: `value`,
                    label: `配置项值`,
                    width: `400`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false,
                    // readonly:false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `textarea`,
                    prop: `description`,
                    label: `描述`,
                    // width: `400`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: false
                },
                {
                    type: `string`,
                    prop: `version`,
                    label: `版本号`,
                    width: `80`,
                    isListable: true,
                    isEditable: false,
                    searchable: false
                }
            ]
        }
    },
    methods: {
        afterUpdate(data) {
            console.log(data)
            this.$root[data.key] = data.value
            console.log(`this.$root.IsWorkerByDuty)=` + this.$root.IsWorkerByDuty)
        },
        loadConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                this.$store.dispatch(`ADD_SYS_DOCUMENT_LIST`).then(data2 => {
                    let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                    req.then(data => {
                        let configs = _.differenceWith(data, this.sys_document_list, function(ath, oth) {
                            return ath.key == oth.value
                        })

                        configs.forEach((data, index) => {
                            let mc = _.find(this.catetory_list, { label: data[`catetory`], value: data[`catetory`] })
                            if (mc) {
                            } else {
                                this.catetory_list.push({ label: data[`catetory`], value: data[`catetory`] })
                            }
                        })
                        that.configsBackUp = _.cloneDeep(configs)
                        if (that.catetory) {
                            that.configsBackUp = _.filter(that.configsBackUp, function(r) {
                                return r.catetory == that.catetory // _.includes()
                            })
                        }
                        resolve(that.configsBackUp)
                    }).catch(e => reject(e))
                })
            })
        },
        reload() {
            this.$refs[`config-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Config/Index.vue